import React from 'react';

// Path to the logo file on your project
import rocketseatLogo from './logo.png';

const Logo = () => (
    <img src={rocketseatLogo} alt="Hosterlabs logo" style={{ width: 180 }} />
);

export default Logo;